export default __webpack_public_path__ + "static/media/rectangles-no-5.3b33c41b.mid";